module.exports = __webpack_public_path__ + "9fb2a576.svg";